import React from 'react'
import { Outlet } from 'react-router-dom'

const Tracking = () => {
  return (
    <Outlet />
  )
}

export default Tracking